/* The cart drawer is the only cart. Safety net: any add-to-cart form that gets submitted without its own handler (a script
   that didn't load, an app's form) is added in place and the drawer opens, instead of the browser going to /cart. Forms
   handled by product-form.js or the buy box have already called preventDefault by the time this runs. */
(function () {
  if (window.__jxCartAddNet) return;
  window.__jxCartAddNet = true;
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var body = new FormData(form);
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
    }
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-disabled', 'true');
    fetch(addUrl, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          var wrap = form.querySelector('.product-form__error-message-wrapper');
          var msg = wrap && wrap.querySelector('.product-form__error-message');
          if (wrap && msg) { msg.textContent = res.description || res.message || ''; wrap.hidden = false; }
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: body.get('id'), cartData: res });
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res);
        else window.location.reload();
      })
      .catch(function () { window.location.reload(); })
      .then(function () { if (button) button.removeAttribute('aria-disabled'); });
  });
})();

/* window.jxCartRedraw(): redraws the drawer and the header cart count from the server. Used by assets/jx-gifts.js after it
   changes gift lines. */
(function () {
  if (window.jxCartRedraw) return;

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  window.jxCartRedraw = function () {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return Promise.all([
      fetch(cartUrl + '?section_id=cart-drawer').then(function (r) { return r.text(); }),
      fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var doc = parse(res[0]);
      var next = doc.querySelector('cart-drawer');
      var cur = document.querySelector('cart-drawer');
      if (next && cur) {
        cur.classList.toggle('is-empty', next.classList.contains('is-empty'));
        var curInner = cur.querySelector('.drawer__inner');
        var nextInner = next.querySelector('.drawer__inner');
        if (curInner && nextInner) curInner.innerHTML = nextInner.innerHTML;
      }
      var bubbleHtml = res[1] && res[1]['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubbleHtml && bubble) {
        var section = parse(bubbleHtml).querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      }
    });
  };
})();
